/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Per_DayInputs */

const en_premium_per_day = /** @type {(inputs: Premium_Per_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/day`)
};

const es_premium_per_day = /** @type {(inputs: Premium_Per_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/día`)
};

/**
* | output |
* | --- |
* | "/day" |
*
* @param {Premium_Per_DayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_per_day = /** @type {((inputs?: Premium_Per_DayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Per_DayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_per_day(inputs)
	return en_premium_per_day(inputs)
});